import { Component, ViewChild } from '@angular/core';
import { PartnerApi } from '../../../../assets/js/lb-sdk';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { finalize } from 'rxjs/operators';
import { PartnerVerificationFormComponent } from './partner-verification-form/partner-verification-form.component';
import { Register } from '../../../classes';

@Component({
    selector: 'app-register-lite',
    templateUrl: './register-lite.component.html',
    styleUrls: ['./register.component.css']
  })
  export class RegisterLiteComponent extends Register {
    @ViewChild('partnerVerificationForm') partnerVerificationForm: PartnerVerificationFormComponent;
    @ViewChild('registrationForm') registrationForm: RegistrationFormComponent;
  
    constructor(private partnerApi: PartnerApi) {
      super();
    }
  
    verifyPartner($event: { event:string, data:any }) {
      switch ($event.event) {
        case 'started':
          this.loader.partnerIdVerification = true;
          this.error = undefined;
          break;
        case 'success':
          this.partner.type = $event.data.exists;
          this.partner.verifiedPartner = true;
          this.next('review');
          this.loader.partnerDetails = true;
          this.partnerApi
            .findById(this.partner.partnerId)
            .pipe(finalize(() => {
              this.loader.partnerDetails = false;
            }))
            .subscribe(
              (data:any) => {
                const {
                  firstName,
                  lastName,
                  accountName,
                  accountName1,
                  objectType
                } = data;
                this.partner = {
                  type: objectType,
                  firstName: firstName || accountName,
                  lastName: lastName || accountName1,
                  ...this.partner
                };
              },
              error => {
                this.error = error && error.message || 'Unable to load partner details';
              }
            );
          break;
        case 'failed':
          this.error = $event.data;
          break;
        case 'ended':
          this.loader.partnerIdVerification = false;
          break;
      }
    }
  }